import { HighlightableButton } from '@monofe/ui-common';
import { IconHamburger, IconMapMarker } from '@monofe/ui-common/icon';
import { memo, useCallback } from 'react';
import { StyleElement, classNameForElement, styleForElement } from './NavigationBarView.style';
import type { IHamburgerNavigationBarProperties } from './interface';

function View(properties: IHamburgerNavigationBarProperties): JSX.Element {
    const style = useCallback(
        (element: StyleElement) => styleForElement(element, properties),
        [properties],
    );
    const className = useCallback(
        (element: StyleElement) => classNameForElement(element, properties),
        [properties],
    );

    return (
        <header
            role="banner"
            className={className(StyleElement.Container)}
            style={style(StyleElement.Container)}
        >
            <h1 className={className(StyleElement.TitleText)} style={style(StyleElement.TitleText)}>
                {properties.title.text ?? ''}
            </h1>
            <HighlightableButton
                description="menu"
                onClick={properties.onHamburgerMenuClick}
                className={className(StyleElement.IconContainerHamburger)}
                style={style(StyleElement.IconContainerHamburger)}
            >
                <IconHamburger
                    className={className(StyleElement.IconHamburger)}
                    style={style(StyleElement.IconHamburger)}
                />
            </HighlightableButton>
            {(properties.showFloorPlanIcon ?? false) && (
                <HighlightableButton
                    isLink
                    description="floorplan"
                    onClick={properties.onFloorPlanClick}
                    href={properties.floorplanHref}
                    className={className(StyleElement.IconContainerFloorPlan)}
                    style={style(StyleElement.IconContainerFloorPlan)}
                >
                    <IconMapMarker
                        className={className(StyleElement.IconFloorPlan)}
                        style={style(StyleElement.IconFloorPlan)}
                    />
                </HighlightableButton>
            )}
        </header>
    );
}

export default memo(View);
